"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DEPOSIT: 2,
  TRANSFER: 3,
  // 5 comp_req was here
  // comp_resp was here
  EXIT: 7,
  VALIDATOR_JOIN: 8,
  VALIDATOR_LOGOUT: 9,
  // 10 was for VALIDATOR_LEAVE
  PERIOD_VOTE: 11,
  EPOCH_LENGTH: 12,
  SPEND_COND: 13,
  MIN_GAS_PRICE: 14
};
module.exports = exports["default"];